
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/deal-details-page/[id]",
      function () {
        return require("private-next-pages/shopping/deal-details-page/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/deal-details-page/[id]"])
      });
    }
  